import dayjs from 'dayjs'
import NP from 'number-precision'

const filters = {
  formatDate (value) {
    if (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    } else {
      return ''
    }
  },
  price (value) {
    if (value) {
      return NP.divide(value, 100)
    } else {
      return 0
    }
  }
}

export default filters
